<template>
    <div>
        <h2>{{ title }}</h2>
        <section class="vcalender">
            <div class="experience vevent vcard">
                <span class="interest-item" v-bind:key="item" v-for="item in json">
                    <span v-html="item"></span>
                </span>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "Interests",
  props: {
    title: String,
    json: Array
  }
};
</script>